import { Api } from '../base/Api';
import { Injectable } from '@angular/core';
import { ShippingFileInfo } from 'src/app/models/ShippingFileInfo';
@Injectable({
    providedIn: 'root'
})
export class ShippingFileApi extends Api<ShippingFileInfo> {
}
